/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Modal,
  Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';

const propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
};

class WarningModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { showModal } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
  }

  render() {
    const { showModal } = this.state;
    const { onHide, text, header } = this.props;
    return (
      <Modal
        show={showModal}
        bsClass="aisz-modal-warning"
        onHide={() => onHide()}
        backdrop="static"
      >
        <Modal.Header closeButton>
          {header}
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            {text}
          </p>
          <Button bsStyle="aisz-warning" onClick={onHide}>确定</Button>
        </Modal.Body>
      </Modal>
    );
  }
}

WarningModal.propTypes = propTypes;

export default WarningModal;




// WEBPACK FOOTER //
// ./src/components/WarningModal/index.jsx